import type { Action } from "../../actions/types";
import { RequestStatus } from "../../types/requestStatus";

export type StoreState = {
  accountCreditRedeem?: RequestStatus;
  accountCreditReverse?: RequestStatus;
  exchangeRedeem?: RequestStatus;
  getLedger?: RequestStatus;
  getShopifyActiveDiscounts?: RequestStatus;
  getShopifyActiveGiftCards?: RequestStatus;
  getShopifyVariants?: RequestStatus;
};

export const initialState = {
  accountCreditRedeem: undefined,
  accountCreditReverse: undefined,
  exchangeRedeem: undefined,
  getLedger: undefined,
  getShopifyActiveDiscounts: undefined,
  getShopifyActiveGiftCards: undefined,
  getShopifyVariants: undefined,
};

// tslint:disable-next-line: cyclomatic-complexity
export function reducer(
  state: StoreState | null = initialState,
  action: Action
): StoreState | null {
  switch (action.type) {
    case "LOYALTY_GET_LEDGER_REQUEST":
      return { ...state, getLedger: "REQUESTING" };

    case "LOYALTY_GET_LEDGER_FAILURE":
      return { ...state, getLedger: "FAILURE" };

    case "LOYALTY_GET_LEDGER_SUCCESS":
      return { ...state, getLedger: "SUCCESS" };

    case "ACCOUNT_CREDIT_REDEEM_REQUEST":
      return { ...state, accountCreditRedeem: "REQUESTING" };

    case "ACCOUNT_CREDIT_REDEEM_FAILURE":
      return { ...state, accountCreditRedeem: "FAILURE" };

    case "ACCOUNT_CREDIT_REDEEM_SUCCESS":
      return { ...state, accountCreditRedeem: "SUCCESS" };

    case "ACCOUNT_CREDIT_REVERSE_REQUEST":
      return { ...state, accountCreditReverse: "REQUESTING" };

    case "ACCOUNT_CREDIT_REVERSE_FAILURE":
      return { ...state, accountCreditReverse: "FAILURE" };

    case "ACCOUNT_CREDIT_REVERSE_SUCCESS":
      return { ...state, accountCreditReverse: "SUCCESS" };

    case "EXCHANGE_REDEEM_REQUEST":
      return { ...state, exchangeRedeem: "REQUESTING" };

    case "EXCHANGE_REDEEM_FAILURE":
      return { ...state, exchangeRedeem: "FAILURE" };

    case "EXCHANGE_REDEEM_SUCCESS":
      return { ...state, exchangeRedeem: "SUCCESS" };

    case "GET_SHOPIFY_ACTIVE_DISCOUNTS_REQUEST":
      return { ...state, getShopifyActiveDiscounts: "REQUESTING" };

    case "GET_SHOPIFY_ACTIVE_DISCOUNTS_FAILURE":
      return { ...state, getShopifyActiveDiscounts: "FAILURE" };

    case "GET_SHOPIFY_ACTIVE_DISCOUNTS_SUCCESS":
      return { ...state, getShopifyActiveDiscounts: "SUCCESS" };

    case "GET_SHOPIFY_ACTIVE_GIFT_CARDS_REQUEST":
      return { ...state, getShopifyActiveGiftCards: "REQUESTING" };

    case "GET_SHOPIFY_ACTIVE_GIFT_CARDS_FAILURE":
      return { ...state, getShopifyActiveGiftCards: "FAILURE" };

    case "GET_SHOPIFY_ACTIVE_GIFT_CARDS_SUCCESS":
      return { ...state, getShopifyActiveGiftCards: "SUCCESS" };

    case "GET_SHOPIFY_VARIANTS_REQUEST":
      return { ...state, getShopifyVariants: "REQUESTING" };

    case "GET_SHOPIFY_VARIANTS_FAILURE":
      return { ...state, getShopifyVariants: "FAILURE" };

    case "GET_SHOPIFY_VARIANTS_SUCCESS":
      return { ...state, getShopifyVariants: "SUCCESS" };

    default:
      return state;
  }
}
